var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, CardBody, CardFooter, CardTitle, Flex, FlexItem, Grid, GridItem, } from "@patternfly/react-core";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { addCartItem } from "../redux/cartReducer";
import { fetchProductById } from "../redux/productsReducer";
import { useAppDispatch, useAppSelector } from "../redux/reduxHook";
import { ProductQuantity } from "./ProductQuantity";
import { ToastNotification } from "./ToastNotification";
export function ProductDetail() {
    var _this = this;
    var _a = useState(1), selected = _a[0], setSelected = _a[1];
    var productId = useParams().productId;
    //console.log(productId);
    var dispatch = useAppDispatch();
    var _b = useAppSelector(function (state) { return state.products.productByIds; }), productsByIds = _b.data, isFetching = _b.isFetching;
    var productDetail = productsByIds === null || productsByIds === void 0 ? void 0 : productsByIds[productId];
    // console.log("product", productDetail, isFetching);
    useEffect(function () {
        dispatch(fetchProductById(productId));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productId]);
    if (isFetching) {
        return _jsx("h1", { children: "Fetching the data from the backend" });
    }
    else if (isEmpty(productDetail)) {
        return _jsx("h1", { children: "No data" });
    }
    var onClickAddToCart = function () { return __awaiter(_this, void 0, void 0, function () {
        var item;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    item = {
                        id: productDetail.id,
                        title: productDetail.title,
                        price: productDetail.price,
                        quantity: selected,
                    };
                    return [4 /*yield*/, dispatch(addCartItem(item))];
                case 1:
                    _a.sent();
                    ToastNotification.addSuccessMessage("Added product in the cart");
                    setSelected(1);
                    return [2 /*return*/];
            }
        });
    }); };
    var onSelectValue = function (quantity) {
        setSelected(quantity);
    };
    return (_jsx(Card, { id: "product-details", isFlat: true, children: _jsxs(Grid, { md: 3, children: [_jsx(GridItem, { children: _jsx("img", { src: productDetail === null || productDetail === void 0 ? void 0 : productDetail.image, alt: productDetail === null || productDetail === void 0 ? void 0 : productDetail.title, height: "380", width: "380" }) }), _jsxs(GridItem, { children: [_jsx(CardTitle, { children: productDetail.title }), _jsx(CardBody, { children: productDetail.description }), _jsx(CardFooter, { children: _jsxs(Flex, { direction: { default: "column" }, children: [_jsxs(FlexItem, { children: ["\u20B9", productDetail.price] }), _jsx(FlexItem, { children: _jsx(ProductQuantity, { onSelectValue: onSelectValue, selectedValue: selected }) }), _jsx(FlexItem, { children: _jsx(Button, { onClick: onClickAddToCart, children: "Add to Cart" }) })] }) })] })] }) }));
}
